"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorInventoryListGrid = void 0;
/* eslint-disable sort-keys */
/* eslint-disable sort-keys-fix/sort-keys-fix */
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const router_1 = require("client/components/router");
const mobx_1 = require("mobx");
const number_formatter_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/number-formatter");
const number_formatter_boolean_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/number-formatter-boolean");
const number_formatter_custom_checkbox_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/number-formatter-custom-checkbox");
const number_formatter_percent_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/number-formatter-percent");
const number_formatter_date_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/number-formatter-date");
require("./distributor-inventory-list-grid.less");
const core_1 = require("@material-ui/core");
const button_1 = require("client/components/material/button");
const distributor_drop_down_1 = require("client/modules/inventory-order/components/distributor-drop-down");
const store_1 = require("client/modules/users/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/inventory-order/store");
const store_4 = require("client/modules/inventory/modules/inventory-list/store");
const throttle_debounce_1 = require("throttle-debounce");
let DistributorInventoryListGrid = class DistributorInventoryListGrid extends React.Component {
    constructor(props) {
        super(props);
        this.selectedRows = [];
        this.originalArray = [];
        this.selectedDistributor = null;
        this.distributorInventories = [];
        this.distributorsList = [];
        this.order = "ASC";
        this.orderBy = "package";
        this.filterText = "";
        /**
         * Load the inventories from db, grouped
         */
        this.loadInventory = throttle_debounce_1.debounce(200, async () => {
            const options = {
                count: 1000,
                distributorId: this.props.params[0],
                order: this.order,
                search: this.filterText,
                start: 0,
                where: "",
                sort: this.orderBy
            };
            await store_4.inventoryListStore.loadInventory(options);
        });
        // method used to update boolean values in backorder column onChange
        this.booleanMethodFromParent = (value) => {
            // console.log("value from boolean:", value);
            const currentCell = this.storeData.gridApi.getFocusedCell();
            const { rowIndex } = currentCell;
            const colId = currentCell.column.getId();
            const rowNode = this.storeData.gridApi.getDisplayedRowAtIndex(rowIndex);
            const cellValue = this.storeData.gridApi.getValue(colId, rowNode) || false;
            rowNode.setDataValue(colId, !cellValue);
        };
        // method used to update boolean values in isDistributor column onChange
        this.checkboxMethodFromParent = (value) => {
            // console.log("value from checkbox:", value);
            const currentCell = this.storeData.gridApi.getFocusedCell();
            const { rowIndex } = currentCell;
            const colId = currentCell.column.getId();
            const rowNode = this.storeData.gridApi.getDisplayedRowAtIndex(rowIndex);
            const cellValue = this.storeData.gridApi.getValue(colId, rowNode) || false;
            rowNode.setDataValue(colId, !cellValue);
        };
        // method used to update date values in expected availability column onChange
        this.dateMethodFromParent = (value) => {
            // console.log("value from date:", value);
            const currentCell = this.storeData.gridApi.getFocusedCell();
            const { rowIndex } = currentCell;
            const colId = currentCell.column.getId();
            const rowNode = this.storeData.gridApi.getDisplayedRowAtIndex(rowIndex);
            rowNode.setDataValue(colId, value);
        };
        this.loadData = async () => {
            var _a;
            if (store_1.usersStore.user.value.siteId) {
                await store_2.sitesDetailStore.readSite(store_1.usersStore.user.value.siteId);
            }
            // load all the distributors to match the selected distributor
            await store_3.inventoryOrderStore.listDistributors();
            this.distributorsList = (_a = store_3.inventoryOrderStore.distributors) !== null && _a !== void 0 ? _a : [];
            this.selectedDistributor = this.distributorsList.find(d => d.id === Number(this.props.params[0]));
            if (!this.selectedDistributor) {
                return;
            }
            // load the grouped inventories to get storeData for agGrid
            await this.loadInventory();
        };
        this.navigateToDistributorListView = () => {
            router_1.RouteManager.transitionTo("/order/distributors");
        };
        this.handleDistributorSelect = async (distributor) => {
            if (!distributor) {
                console.error(`Distributor ${distributor} not found in handleDistributorSelect`);
                return;
            }
            store_4.inventoryListStore.inventoryFormatted.value = null;
            store_4.inventoryListStore.inventoryFormattedOrig.value = null;
            store_4.inventoryListStore.showLoader = true;
            router_1.RouteManager.transitionTo(`${distributor.id}`);
            this.selectedDistributor = distributor;
            await this.loadData();
        };
        /**
         * Figure out the inventories to save based on which inventories are changed in ag grid.
         * Then call inventoryOrderStore.saveDistributorInventories endpoint passing in the inventories to save.
         */
        this.onHandleSubmit = async () => {
            var _a;
            store_4.inventoryListStore.showLoader = true;
            const checkChange = () => {
                const diffObjs = this.storeData.rowData.filter((obj, i) => JSON.stringify(obj) !== this.originalArray[i]);
                return diffObjs;
            };
            const inventoriesToSubmit = checkChange();
            // console.log("objects to submit:", inventoriesToSubmit);
            if (inventoriesToSubmit.length) {
                const distributorToUpdate = {
                    id: (_a = this.selectedDistributor) === null || _a === void 0 ? void 0 : _a.id,
                    inventoriesToChange: inventoriesToSubmit
                };
                // console.info("distributorToUpdate is", distributorToUpdate);
                store_4.inventoryListStore.inventoryFormatted.value = null;
                store_4.inventoryListStore.inventoryFormattedOrig.value = null;
                await store_3.inventoryOrderStore.saveDistributorInventories(distributorToUpdate);
                await this.loadData();
            }
            store_4.inventoryListStore.showLoader = false;
            // console.log("save is done");
        };
        this.storeData = {
            defaultColDef: {
                comparator: (a, b) => {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    return a > b ? 1 : a < b ? -1 : 0;
                },
                // enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                filter: true,
                resizable: true,
                sortable: true
            },
            columnDefs: [
                {
                    headerName: "GROUP NAME",
                    field: "isDistributor",
                    // filter: "agTextColumnFilter",
                    showRowGroup: true,
                    resizable: true,
                    // skipHeaderOnAutoSize: true,
                    // minWidth: 500,
                    // hide: true
                    cellRenderer: "numberFormatterCustomCheckbox",
                    // cellRenderer: "agGroupCellRenderer",
                    cellRendererParams: {
                        suppressCount: true,
                        // checkbox: true, // if we want to go back to group checkboxes, we only need this
                        // innerRenderer: "numberFormatterCustomCheckbox", // was not working with agGroupCellRenderer
                        suppressDoubleClickExpand: true,
                        suppressEnterExpand: true
                    }
                    // checkboxSelection: true,
                    // headerCheckboxSelection: true
                },
                {
                    headerName: "GROUP",
                    field: "group",
                    rowGroup: true,
                    minWidth: 500,
                    hide: true
                    // filter: "agTextColumnFilter",
                    // enableRowGroup: true
                    // checkboxSelection: true
                },
                {
                    headerName: "DIST SELECTED",
                    field: "isDistributor",
                    hide: true
                    // filter: "agTextColumnFilter",
                    // enableRowGroup: true
                },
                {
                    headerName: "NAME",
                    field: "name",
                    minWidth: 500,
                    hide: true
                    // filter: "agTextColumnFilter",
                    // enableRowGroup: true
                },
                {
                    headerName: "NDC",
                    field: "ndc"
                    // filter: "agTextColumnFilter",
                    // enableRowGroup: true
                },
                {
                    headerName: "PKG QTY/FORM",
                    field: "qty"
                    // filter: "agTextColumnFilter"
                },
                {
                    headerName: "DIST PRICE",
                    field: "inventoryPrice",
                    // filter: "agNumberColumnFilter",
                    type: "valueColumn",
                    editable: true,
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "COST TO COMPANY",
                    field: "imbCost",
                    // filter: "agNumberColumnFilter",
                    type: "valueColumn",
                    // valueGetter: (params: any) => {
                    //   if (!!params.data) {
                    //     const price = params.data.distPrice;
                    //     const profit = params.data.dollarProfit;
                    //     const cost = price - profit;
                    //     return params.data[cost+"imbCost"];
                    //   }
                    // },
                    // aggFunc: "sum",
                    editable: true,
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "$ PROFIT",
                    field: "dollarProfit",
                    colId: "dollarProfit",
                    // filter: "agNumberColumnFilter",
                    type: "valueColumn",
                    valueGetter: (params) => {
                        // console.log("params data in profit", params.data);
                        if (!!params.data) {
                            const price = params.data.inventoryPrice;
                            const cost = params.data.imbCost;
                            return price - cost;
                        }
                    },
                    // editable: true,
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "% PROFIT",
                    field: "percentProfit",
                    colId: "percentProfit",
                    type: "valueColumn",
                    valueGetter: (params) => {
                        // console.log("params data in %profit", params.data);
                        if (!!params.data) {
                            const profit = params.getValue("dollarProfit");
                            const cost = params.data.imbCost;
                            if (cost > 0) {
                                return (profit / cost) * 100;
                            }
                            return 0;
                        }
                    },
                    // editable: true,
                    cellRenderer: "numberFormatterPercent"
                },
                {
                    headerName: "BACKORDER",
                    field: "isBackorder",
                    colId: "backorder",
                    cellRenderer: "numberFormatterBoolean",
                    editable: true
                },
                // editable :true
                {
                    headerName: "EXPECTED AVAILABILITY",
                    field: "backorderExpectedDate",
                    colId: "expDate",
                    cellRenderer: "numberFormatterDate",
                    editable: false
                },
                {
                    headerName: "LAST EDIT",
                    field: "lastEdit"
                    // filter: "agDateColumnFilter",
                    // filterParams: {
                    //   comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
                    //     const dateAsString = cellValue;
                    //     if (dateAsString === null) return -1;
                    //     const dateParts = dateAsString.split("/");
                    //     const cellDate = new Date(
                    //       Number(dateParts[2]),
                    //       Number(dateParts[0]) - 1,
                    //       Number(dateParts[1])
                    //     );
                    //     if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
                    //       return 0;
                    //     }
                    //     if (cellDate < filterLocalDateAtMidnight) {
                    //       return -1;
                    //     }
                    //     if (cellDate > filterLocalDateAtMidnight) {
                    //       return 1;
                    //     }
                    //   },
                    //   browserDatePicker: true
                    // }
                },
                // E-057 UAT
                {
                    headerName: "LAST UPDATE USER",
                    field: "lastEditUser",
                    minWidth: 500,
                    editable: false
                },
            ],
            columnTypes: {
                valueColumn: {
                    valueParser: "Number(newValue)",
                    filter: "agNumberColumnFilter"
                },
            },
            rowClassRules: {
                "inv-selected": (params) => {
                    if (!!params.data) {
                        const isDist = params.data.isDistributor;
                        return isDist === true;
                    }
                }
            },
            rowSelection: "single",
            groupDefaultExpanded: 1,
            rowData: [],
            context: { componentParent: this },
            multiSortKey: "ctrl",
            // floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter,
                numberFormatterBoolean: number_formatter_boolean_1.NumberFormatterBoolean,
                numberFormatterCustomCheckbox: number_formatter_custom_checkbox_1.NumberFormatterCustomCheckbox,
                numberFormatterPercent: number_formatter_percent_1.NumberFormatterPercent,
                numberFormatterDate: number_formatter_date_1.NumberFormatterDate
            }
        };
    }
    async componentDidMount() {
        store_4.inventoryListStore.showLoader = true;
        await this.loadData();
    }
    componentWillUnmount() {
        store_4.inventoryListStore.inventoryFormatted.value = null;
        store_4.inventoryListStore.inventoryFormattedOrig.value = null;
    }
    render() {
        var _a;
        // const storeDataOriginal: Partial<IInventoryGroup>[] =
        //   inventoryListStore.inventory.value;
        // console.log("storeDataOriginal in render", storeDataOriginal);
        const storeData = store_4.inventoryListStore.inventoryFormatted.value;
        // console.log("storeData in render", storeData);
        const storeDataOrig = (_a = store_4.inventoryListStore.inventoryFormattedOrig.value) !== null && _a !== void 0 ? _a : [];
        this.originalArray = storeDataOrig.map((obj) => JSON.stringify(obj));
        this.storeData.rowData = storeData;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "inventory-order__distributors" },
                React.createElement(core_1.Typography, { variant: "display1" }, "Distributors"),
                React.createElement("div", { className: "selected-distributor-header" },
                    React.createElement(core_1.Typography, { variant: "title" }, this.selectedDistributor
                        ? this.selectedDistributor.distributor
                        : ""),
                    React.createElement("div", { className: "selected-distributor-header--right" },
                        React.createElement(button_1.MaterialButton, { secondary: true, onClick: this.navigateToDistributorListView }, "view distributors"),
                        React.createElement(distributor_drop_down_1.DistributorDropDown, { selectedDistributor: this.selectedDistributor, onSelect: this.handleDistributorSelect })))),
            storeData && storeData.length > 0 && (React.createElement("div", { className: "ag-theme-balham", style: {
                    height: "65vh",
                    width: "100%"
                } },
                React.createElement("hr", null),
                React.createElement("button", { type: "submit", onClick: this.onHandleSubmit.bind(this) }, "SAVE DISTRIBUTOR INVENTORIES"),
                React.createElement("hr", null),
                React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => (this.storeData.gridApi = params.api), columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, groupSuppressAutoColumn: true, 
                    // suppressRowClickSelection={true}
                    groupDefaultExpanded: this.storeData.groupDefaultExpanded, frameworkComponents: this.storeData.frameworkComponents, columnTypes: this.storeData.columnTypes, context: this.storeData.context, multiSortKey: this.storeData.multiSortKey, animateRows: true, 
                    // sideBar={true}
                    suppressExcelExport: true, rowClassRules: this.storeData.rowClassRules, rowSelection: this.storeData.rowSelection, 
                    // the following is used if we implement group checkbox selection
                    // groupSelectsChildren={true}
                    rowData: this.storeData.rowData }))),
            storeData && store_4.inventoryListStore.showLoader && (React.createElement(React.Fragment, null,
                React.createElement("div", null, "Loading Data..."))),
            store_4.inventoryListStore.showLoader ? (
            // <div className="loader">
            //   <UiLoadingIndicator />
            // </div>
            // <div className="ui-form__loading-bg ui-form__loading-bg--loading" > caused loader issue i removed class only 2025-02-01 22:05:00
            React.createElement("div", { className: "ui-form__loading-bg" },
                React.createElement(ui_1.UiLoadingIndicator, { className: "ui-form__loading-indicator" }))) : null));
    }
    //   private onButtonExport = () => {
    //     const params = {
    //       fileName: "Negative_Balances.csv"
    //     };
    //     this.storeData.gridApi.exportDataAsCsv(params);
    //   };
    onSelectionChanged() {
        this.selectedRows = this.storeData.gridApi.getSelectedRows();
        console.log("selected rows:", this.selectedRows);
        let selectedRowsString = "";
        this.selectedRows.forEach((selectedRow, index) => {
            if (index !== 0) {
                selectedRowsString += ", ";
            }
            selectedRowsString += selectedRow.RXNumber;
        });
        document.querySelector("#selectedRows").innerHTML = selectedRowsString;
    }
};
__decorate([
    mobx_1.observable
], DistributorInventoryListGrid.prototype, "selectedRows", void 0);
__decorate([
    mobx_1.observable
], DistributorInventoryListGrid.prototype, "originalArray", void 0);
__decorate([
    mobx_1.observable
], DistributorInventoryListGrid.prototype, "selectedDistributor", void 0);
__decorate([
    mobx_1.observable
], DistributorInventoryListGrid.prototype, "distributorInventories", void 0);
__decorate([
    mobx_1.observable
], DistributorInventoryListGrid.prototype, "distributorsList", void 0);
__decorate([
    mobx_1.observable
], DistributorInventoryListGrid.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], DistributorInventoryListGrid.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], DistributorInventoryListGrid.prototype, "filterText", void 0);
DistributorInventoryListGrid = __decorate([
    mobx_react_1.observer
], DistributorInventoryListGrid);
exports.DistributorInventoryListGrid = DistributorInventoryListGrid;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/distributors/components/distributor-inventory-list/distributor-inventory-list-grid.tsx
// module id = 3527
// module chunks = 0